import { render } from "./RegisterPanel.vue?vue&type=template&id=487901f6&scoped=true"
import script from "./RegisterPanel.vue?vue&type=script&lang=js"
export * from "./RegisterPanel.vue?vue&type=script&lang=js"

import "./RegisterPanel.vue?vue&type=style&index=0&id=487901f6&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-487901f6"]])

export default __exports__